import angular from 'angular';
import _ from 'underscore';

export default class UserOfferMatching {
  constructor($scope, UserService, OfferService) {
    $scope.tabs = [{
      title: 'Matched Offers',
      offers: [],
      loading: false,
      checked: false
    }];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
      $scope.query = '';
    };

    $scope.get_supplier_label = function(supplier) {
      return supplier.company + ' (' + supplier.id + ')';
    };

    $scope.quick_search = function() {
      window.filter_table('table#offers', $scope.query);
    };

    $scope.get_matched_offers = function() {
      var tab = 0;
      $scope.query = '';
      $scope.tabs[tab].offers = [];
      $scope.tabs[tab].loading = true;
      $scope.tabs[tab].checked = false;
      UserService.get_matched_offers($scope.user_id, $scope.filter).then(function(data) {
        $scope.tabs[tab].offers = data.offers;
        $scope.tabs[tab].loading = false;
      });
    };

    $scope.check_offers = function() {
      var tab = $scope.tabs[$scope.selected_tab];
      angular.forEach(tab.offers, function(offer) {
        offer.checked = tab.checked;
      });
    };

    $scope.get_offer_matched_items = function(index) {
      var offer = $scope.analysis_offers[index];
      OfferService.get_matched_items(offer.id, $scope.user_id, $scope.filter, false).then(function(data) {
        console.log(data);
        offer.items = data.items;
        offer.items_quantity = window.roundToTwo(_.reduce(_.pluck(data.items, 'quantity'), function(quantity, num) {
          return quantity + num;
        }, 0));
        offer.items_quality_accuracy = Math.floor(_.reduce(_.pluck(data.items, 'quality_accuracy'), function(accuracy, num) {
          return accuracy + num;
        }, 0) / data.items.length);
        offer.items_specs_accuracy = Math.floor(_.reduce(_.pluck(data.items, 'specs_accuracy'), function(accuracy, num) {
          return accuracy + num;
        }, 0) / data.items.length);
        offer.unique_products = _.uniq(_.compact(_.pluck(data.items, 'product_id')));
        offer.accurate_items = _.filter(data.items, function(item) {
          return item.specs_accuracy >= 80;
        });
        offer.accurate_items_quantity = window.roundToTwo(_.reduce(_.pluck(offer.accurate_items, 'quantity'), function(quantity, num) {
          return quantity + num;
        }, 0));
        if (index < $scope.analysis_offers.length - 1)
          $scope.get_offer_matched_items(index + 1);
      });
    };

    $scope.standard_analysis = function() {
      var tab = $scope.tabs[0];
      $scope.analysis_offers = [];
      angular.forEach(tab.offers, function(offer) {
        if (offer.checked) {
          offer.items = null;
          offer.items_quantity = null;
          offer.items_quality_accuracy = null;
          offer.items_specs_accuracy = null;
          offer.unique_products = null;
          offer.accurate_items = null;
          offer.accurate_items_quantity = null;
          $scope.analysis_offers.push(offer);
        }
      });
      $scope.get_offer_matched_items(0);
    };

    $scope.get_analysis_url = function(offer_id) {
      return '/admin/marketplace/offers/edit_user_pricing/' + offer_id + '?user_id=' + window.user_id;
    };

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.show_by_min_quantity = function(offer) {
      var min_quantity = parseInt($scope.filter.min_quantity);
      if (!isNaN(min_quantity) && offer.items_quantity)
        return offer.items_quantity >= min_quantity;
      else
        return true;
    };

    $scope.filter = {
      buyer_id: window.user_id,
      supplier_id: null,
      date_from: null,
      date_to: null,
      user_countries: [],
      has_specs: 'all',
      user_group: 'all',
      business_relation: -1,
      pre_min_quality_accuracy: 1,
      pre_min_specs_accuracy: 1,
      min_quality_accuracy: 1,
      min_specs_accuracy: 1,
      specs_method_standard: true,
      specs_method_relative: false,
      specs_method_special: false,
      specs_method_advanced: false,
      specs_matching_accurate: true,
      specs_matching_flexible: true,
      specs_matching_basic_only: false,
      min_quantity: 0
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.user_id = window.user_id;
      $scope.suppliers = window.suppliers;
    };

    $scope.init();
  }
}

UserOfferMatching.$inject = ['$scope', 'UserService', 'OfferService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-offer-matching.ctrl.js